import legoLogo from 'images/lego-sponsor-logo.png';
import GetConfig from './GetConfig';
import { trackEvent } from '../infrastructure/tracking/GoogleAnalytics';

export interface SponsorConfig {
  logo: string;
  url: string;
  alt: string;
  track: () => void;
}

export const getSponsorConfig = (): SponsorConfig | null => {
  let isLegolandActive = false;

  try {
    const config = GetConfig();
    if (typeof config.isLegolandTakeoverActive === 'boolean') {
      isLegolandActive = config.isLegolandTakeoverActive;
    }
  } catch {
    isLegolandActive = false;
  }

  // Only render sponsor logos while the takeover window is active.
  if (!isLegolandActive) {
    return null;
  }

  return {
    logo: legoLogo,
    url: 'https://www.legoland.com/?utm_source=matching_moments&utm_medium=logo&utm_campaign=countdown_to_christmas_2025',
    alt: 'LEGOLAND Resorts',
    track: () => trackEvent('LEGOLAND Logo', 'LEGOLAND Click', 'Landing'),
  };
};
